// Default (variant) sensitivity compares letters first and case only to break a tie, so the order
// is A–Z ignoring case, and of two words that differ only by case the capitalized one comes first.
const DICTIONARY_ORDER = new Intl.Collator('en', { caseFirst: 'upper' })

/** The custom words in display order (A–Z ignoring case, capitalized first on a tie), as a new array. */
export function sortDictionaryWords(words: readonly string[]): string[] {
  return [...words].sort(DICTIONARY_ORDER.compare)
}
